import { AssetActionsProvider, AssetActionButton, AssetActionsDropdown } from 'asset-actions-lib';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONTENT_ACTION_IDS } from '../constants/actionIds';
import { useContentActions } from '../providers/ContentActionsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SocialActionsDropdown = ({
  socialActionsToBeExcluded = [],
  contentRowActions
}) => {
  const actionIdsToExclude = contentRowActions.reduce((acc, {
    id
  }) => {
    if (id !== CONTENT_ACTION_IDS.PROMOTE_SOCIAL_POST && id !== CONTENT_ACTION_IDS.PROMOTE_AD_CAMPAIGN) {
      acc.push(id);
    }
    return acc;
  }, [...socialActionsToBeExcluded]);
  return /*#__PURE__*/_jsx(AssetActionsDropdown, {
    actionIdsToExclude: actionIdsToExclude,
    buttonUse: "secondary",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-actions-lib.contentDetailsActions.promoteDropdown"
    })
  });
};
const ContentDetailActions = ({
  crmObject,
  trackerProps,
  socialActionsConfig = {
    hasSocialActions: false,
    actionsToBeExcluded: []
  },
  primaryActionId,
  secondaryActionId,
  extraActionIdsToExclude = []
}) => {
  const {
    contentRowActions,
    onActionError
  } = useContentActions();
  return /*#__PURE__*/_jsx(AssetActionsProvider, {
    actions: contentRowActions,
    crmObject: crmObject,
    trackerProps: trackerProps,
    onActionError: onActionError,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      "data-test-id": "asset-actions-buttons-layout",
      children: [/*#__PURE__*/_jsx(AssetActionsDropdown, {
        actionIdsToExclude: [...extraActionIdsToExclude, CONTENT_ACTION_IDS.PROMOTE_AD_CAMPAIGN, CONTENT_ACTION_IDS.PROMOTE_SOCIAL_POST, CONTENT_ACTION_IDS.EDIT, CONTENT_ACTION_IDS.DETAILS],
        buttonUse: "secondary",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-actions-lib.contentDetailsActions.moreDropdown"
        })
      }), socialActionsConfig && socialActionsConfig.hasSocialActions ? /*#__PURE__*/_jsx(SocialActionsDropdown, {
        socialActionsToBeExcluded: socialActionsConfig === null || socialActionsConfig === void 0 ? void 0 : socialActionsConfig.actionsToBeExcluded,
        contentRowActions: contentRowActions
      }) : null, secondaryActionId && /*#__PURE__*/_jsx(AssetActionButton, {
        actionId: secondaryActionId,
        "data-test-id": "secondary-action-button",
        use: "secondary"
      }), /*#__PURE__*/_jsx(AssetActionButton, {
        actionId: primaryActionId || CONTENT_ACTION_IDS.EDIT,
        "data-test-id": "primary-action-button",
        use: "primary"
      })]
    })
  });
};
export default ContentDetailActions;